define('models/event',["require", "exports"], function (require, exports) {
    "use strict";
    var EventArgs = (function () {
        function EventArgs() {
        }
        Object.defineProperty(EventArgs, "empty", {
            get: function () {
                return new EventArgs();
            },
            enumerable: true,
            configurable: true
        });
        return EventArgs;
    }());
    exports.EventArgs = EventArgs;
    var EventHandler = (function () {
        function EventHandler(handler) {
            this._handler = handler;
        }
        EventHandler.prototype.handle = function (sender, e) {
            this._handler(sender, e);
        };
        return EventHandler;
    }());
    exports.EventHandler = EventHandler;
    var Delegate = (function () {
        function Delegate() {
            this._eventHandlers = new Array();
        }
        Delegate.prototype.add = function (eventHandler) {
            if (this._eventHandlers.indexOf(eventHandler) == -1) {
                this._eventHandlers.push(eventHandler);
            }
        };
        Delegate.prototype.remove = function (eventHandler) {
            var i = this._eventHandlers.indexOf(eventHandler);
            if (i != -1) {
                this._eventHandlers.splice(i, 1);
            }
        };
        Delegate.prototype.raise = function (sender, e) {
            for (var i = 0; i < this._eventHandlers.length; i++) {
                this._eventHandlers[i].handle(sender, e);
            }
        };
        return Delegate;
    }());
    exports.Delegate = Delegate;
});

